import React, { useState, useEffect } from "react";
import {
  useCreateClientTransactionMutation,
  useLazyGetMainQuery,
} from "services/clientApi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import FormStep1 from "./FormStep1";
import FormStep2 from "./FormStep2";
import FormStep3 from "./FormStep3";
import "./transfer.scss";

const Form = ({
  setTransactionStep,
  setAttentionData,
  transactionStep,
  main
}) => {
  const [data, setFormData] = useState("");
  const [createTransaction] = useCreateClientTransactionMutation();
  const screenWidth = useSelector((state) => state?.common?.screenWidth);
  const [isMobile, setIsMobile] = useState("");
  const [getMain] = useLazyGetMainQuery();
  const [formStep1SelectedOption, setFormStep1SelectedOption] = useState(null);
  const [canGoNext, setCanGoNext] = useState(false);

  useEffect(() => {
    setIsMobile(["lg", "md", "sm", "xs"].includes(screenWidth));
  }, [screenWidth]);

  const handleChange = (e) => {
    setFormData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (event) => {
    if (event) event.preventDefault();

    const result = await createTransaction({ transferType: '1', data });

    if ("error" in result) {
      console.log("error");
    } else {
      setAttentionData(result.data);
      setTransactionStep("step-4");
      getMain();
      toast.success("Created Successfully");
      setFormData("");
    }
  };

  const handleGoBack = () => {
    if (transactionStep === 'step-3')
      setTransactionStep('step-2')
    else if (transactionStep === 'step-2')
      setTransactionStep('step-1')
  }

  const handleGoNext = () => {
    if (!canGoNext) return;

    switch (transactionStep) {
      case 'step-1':
        setTransactionStep('step-2');
        break;
      case 'step-2':
        setTransactionStep('step-3');
        break;
      default:
        setTimeout(() => {
          handleSubmit();
        }, 0);
    }
  }

  useEffect(() => {
    if (data.beneficary_name &&
      data.beneficary_country &&
      data.bank_name &&
      data.swift_code &&
      data.iban &&
      data.amount &&
      data.description &&
      transactionStep === "step-1")
      setCanGoNext(true)

    if (transactionStep === "step-2" && !data.execution_date)
      setCanGoNext(false)

    if (transactionStep === "step-2" && data.execution_date && formStep1SelectedOption)
      setCanGoNext(true)
  }, [data, transactionStep])

  return (
    <div className="w-100 p-2 md:p-4 m-auto bg-white rounded my-2">

      {transactionStep === "step-1" &&
        (
          <FormStep2
            isMobile={isMobile}
            setTransactionStep={setTransactionStep}
            handleChange={handleChange}
            main={main}
            data={data} />
        )}

      {transactionStep === "step-2" &&
        (
          <FormStep1
            setFormStep1SelectedOption={setFormStep1SelectedOption}
            handleChange={handleChange}
            formStep1SelectedOption={formStep1SelectedOption}
            data={data} />
        )}

      {transactionStep === "step-3" &&
        (
          <FormStep3
            formStep1SelectedOption={formStep1SelectedOption}
            main={main}
            data={data} />
        )}

      <div className="d-flex w-95 m-auto justify-content-between">
        <div
          className={`d-flex gap-2 align-items-center mb-3 btn  ${transactionStep === "step-1" ? "btn-primary disabled" : "btn-primary"} customBordRad`}
          type="button"
          onClick={transactionStep === "step-2" ? handleGoBack : null}
          style={{ cursor: transactionStep === "step-1" ? "not-allowed" : "pointer", opacity: transactionStep === "step-1" ? 0.5 : 1 }}
        >
          <i className="fa-solid fa-arrow-left" />
          {transactionStep === "step-3" ? (
            <p className="mb-0" onClick={() => setTransactionStep('step-1')}>MODIFY</p>
          ) : (
            <p className="mb-0">BACK</p>
          )}
        </div>

        <div className={`d-flex gap-2 align-items-center mb-3 btn text-white ${!canGoNext ? "btn-primary disabled" : "btn-primary pulse-css"} customBordRad`} type="button" onClick={handleGoNext}>
          <p className="mb-0">{transactionStep === "step-3" ? "CONFIRM" : "NEXT"}</p>
          <i className="fa-solid fa-arrow-right" />
        </div>
      </div>
    </div>
  );
};

export default Form;
